import { Button, message, Modal, Pagination, Spin, Table } from "antd";
import axios from "axios";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import JSZip from "jszip";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Barcode from "react-barcode";
import { Col, Row } from "react-bootstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";
import ReactToPrint from "react-to-print";
import documentloader from "../../../Assets/Images/awbcustomsloader.gif";
// import Companyseal from "../../../Assets/Images/seal.JPG";
import Companyseal from "../../../Assets/Images/sahari-seal.png";
import { API, Headers } from "../../../Config";
import { POST } from "../../../Config/ApiRequests";

function PrintCustomsInvoiceModalB(props) {
  const componentRef = useRef();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [Loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [showExcel, setShowExcel] = useState(false);
  const [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const [isLoading2, setIsLoading2] = useState(false);
  const [selectedRate, setSelectedRate] = useState({});
  const [exchangeRates, setexchangeRates] = useState([]);
  console.log("awb modal --- ", props);

  // Function to calculate how many items can fit on the first page
  const calculateItemsPerPage = (totalItems) => {
    // Optimized to fit 70 items on first page with fixed signature/seal
    if (totalItems <= 70) {
      return totalItems;
    } else if (totalItems <= 90) {
      return 70;
    } else if (totalItems <= 110) {
      return 80;
    } else {
      return 90;
    }
  };

  // Function to split items into pages with smart logic
  const splitItemsIntoPages = (items) => {
    const totalItems = items.length;

    if (totalItems <= 70) {
      return {
        firstPageItems: items,
        remainingItems: [],
        hasMultiplePages: false,
      };
    }

    const itemsPerFirstPage = calculateItemsPerPage(totalItems);
    const firstPageItems = items.slice(0, itemsPerFirstPage);
    const remainingItems = items.slice(itemsPerFirstPage);

    return {
      firstPageItems,
      remainingItems,
      hasMultiplePages: remainingItems.length > 0,
    };
  };

  // Function to render items table with 3-column layout - OPTIMIZED FOR 70 ITEMS
  const renderItemsTable = (
    items,
    startIndex = 0,
    isFirstPage = true,
    basicValue = 0,
    frieghtValue = 0,
    InsuranceValue = 0,
    totalValue = 0
  ) => {
    // Sort items: numerically if item is a number, alphabetically otherwise
    const sortedItems = [...items].sort((a, b) => {
      const itemA = a.item.toString().trim();
      const itemB = b.item.toString().trim();

      // Check if both items are numeric
      const isNumericA = !isNaN(parseFloat(itemA)) && isFinite(itemA);
      const isNumericB = !isNaN(parseFloat(itemB)) && isFinite(itemB);

      if (isNumericA && isNumericB) {
        // Sort numerically
        return parseFloat(itemA) - parseFloat(itemB);
      } else {
        // Sort alphabetically (case-insensitive)
        return itemA.localeCompare(itemB, undefined, { sensitivity: "base" });
      }
    });

    const totalItems = sortedItems.length;
    const itemsPerColumn = Math.ceil(totalItems / 3);

    return (
      <table
        className="print-invoice-table"
        style={{ width: "100%", borderCollapse: "collapse" }}
      >
        <tr>
          <td colSpan={3} style={{ border: "none", padding: "0" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: "2px",
                margin: "0",
                padding: "0",
              }}
            >
              {/* First Column */}
              <table
                className="print-invoice-table"
                style={{
                  width: "32%",
                  margin: "0",
                  padding: "0",
                  borderSpacing: "0",
                  borderCollapse: "collapse",
                }}
              >
                <tr>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Description
                    </div>
                  </th>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                      width: "15%",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Qty
                    </div>
                  </th>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                      width: "20%",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Value
                    </div>
                  </th>
                </tr>
                {sortedItems.slice(0, itemsPerColumn).map((item, index) => (
                  <tr key={item.id || index}>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        fontSize: "8px",
                        verticalAlign: "top",
                        width: "65%",
                        height: "14px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ lineHeight: "1.1", margin: "0" }}
                      >
                        {startIndex + index + 1}. {item.item}
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "center",
                        fontSize: "8px",
                        width: "15%",
                        height: "14px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        {item.quantity}
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "right",
                        fontSize: "8px",
                        width: "20%",
                        height: "14px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        {Number(
                          Number(item.value) *
                            item.quantity *
                            Number(selectedRate?.sar_usd)
                        ).toFixed(2)}
                      </div>
                    </td>
                  </tr>
                ))}
              </table>

              {/* Second Column */}
              <table
                className="print-invoice-table"
                style={{
                  width: "32%",
                  margin: "0",
                  padding: "0",
                  borderSpacing: "0",
                  borderCollapse: "collapse",
                }}
              >
                <tr>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Description
                    </div>
                  </th>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                      width: "15%",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Qty
                    </div>
                  </th>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                      width: "20%",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Value
                    </div>
                  </th>
                </tr>
                {sortedItems
                  .slice(itemsPerColumn, itemsPerColumn * 2)
                  .map((item, index) => (
                    <tr key={item.id || index + itemsPerColumn}>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          padding: "2px",
                          fontSize: "8px",
                          verticalAlign: "top",
                          width: "65%",
                          height: "14px",
                        }}
                      >
                        <div
                          className="print-customer-invoice-pdf-txt"
                          style={{ lineHeight: "1.1", margin: "0" }}
                        >
                          {startIndex + index + itemsPerColumn + 1}. {item.item}
                        </div>
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          padding: "2px",
                          textAlign: "center",
                          fontSize: "8px",
                          width: "15%",
                          height: "14px",
                        }}
                      >
                        <div
                          className="print-customer-invoice-pdf-txt"
                          style={{ margin: "0" }}
                        >
                          {item.quantity}
                        </div>
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          padding: "2px",
                          textAlign: "right",
                          fontSize: "8px",
                          width: "20%",
                          height: "14px",
                        }}
                      >
                        <div
                          className="print-customer-invoice-pdf-txt"
                          style={{ margin: "0" }}
                        >
                          {Number(
                            Number(item.value) *
                              item.quantity *
                              Number(selectedRate?.sar_usd)
                          ).toFixed(2)}
                        </div>
                      </td>
                    </tr>
                  ))}
              </table>

              {/* Third Column */}
              <table
                className="print-invoice-table"
                style={{
                  width: "32%",
                  margin: "0",
                  padding: "0",
                  borderSpacing: "0",
                  borderCollapse: "collapse",
                }}
              >
                <tr>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Description
                    </div>
                  </th>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                      width: "15%",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Qty
                    </div>
                  </th>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                      width: "20%",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Value
                    </div>
                  </th>
                </tr>
                {sortedItems.slice(itemsPerColumn * 2).map((item, index) => (
                  <tr key={item.id || index + itemsPerColumn * 2}>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        fontSize: "8px",
                        verticalAlign: "top",
                        width: "65%",
                        height: "14px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ lineHeight: "1.1", margin: "0" }}
                      >
                        {startIndex + index + itemsPerColumn * 2 + 1}.{" "}
                        {item.item}
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "center",
                        fontSize: "8px",
                        width: "15%",
                        height: "14px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        {item.quantity}
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "right",
                        fontSize: "8px",
                        width: "20%",
                        height: "14px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        {Number(
                          Number(item.value) *
                            item.quantity *
                            Number(selectedRate?.sar_usd)
                        ).toFixed(2)}
                      </div>
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </td>
        </tr>
        {isFirstPage && (
          <tr>
            <td colSpan={3} style={{ padding: "5px 0" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "1px solid #bfbfbf",
                }}
              >
                <tr>
                  <td
                    style={{
                      border: "1px solid #bfbfbf",
                      textAlign: "center",
                      padding: "4px",
                      fontSize: "9px",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{ margin: "0", fontWeight: "bold" }}
                    >
                      Basic Value: {basicValue}
                    </div>
                  </td>
                  <td
                    style={{
                      border: "1px solid #bfbfbf",
                      textAlign: "center",
                      padding: "4px",
                      fontSize: "9px",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{ margin: "0", fontWeight: "bold" }}
                    >
                      Freight @ 20%: {frieghtValue}
                    </div>
                  </td>
                  <td
                    style={{
                      border: "1px solid #bfbfbf",
                      textAlign: "center",
                      padding: "4px",
                      fontSize: "9px",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{ margin: "0", fontWeight: "bold" }}
                    >
                      Insurance @ 1.125%: {InsuranceValue}
                    </div>
                  </td>
                  <td
                    style={{
                      border: "1px solid #bfbfbf",
                      textAlign: "center",
                      padding: "4px",
                      fontSize: "9px",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{ margin: "0", fontWeight: "bold" }}
                    >
                      Total Value: ${totalValue}
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        )}
      </table>
    );
  };

  // Function to render terms and conditions - OPTIMIZED FOR 70 ITEMS WITH BREATHING ROOM
  const renderTermsAndConditions = (item) => (
    <tr>
      <td colSpan={7}>
        <div
          className="print-customer-invoice-pdf-txt"
          style={{
            margin: "2px 0",
            fontSize: "8px",
            lineHeight: "1.2",
          }}
        >
          1. I.Mr/Mrs <b>{item.iqama_name}</b> ID:<b>{item.iqama_number}</b> for
          my family/friends, personal use as gift.not for sale. Shipper also
          declare that he is liable of any customs duty/fine / penalites against
          this shipment at origin and destination
        </div>
        <div
          className="print-customer-invoice-pdf-txt"
          style={{
            margin: "2px 0",
            fontSize: "8px",
            lineHeight: "1.2",
          }}
        >
          2. Shipper certifies that the particulars on the face here of are
          correct and that insofar as any part of the consignemt contains
          Dangerous Goods if any surch part is property by name and is in proper
          condition for carriage by air according to the Internation Transport
          Association's applicable dangerous goods regulations and civil
          Aviation Regulation of the United Arab Emirates.
        </div>
        <div
          className="print-customer-invoice-pdf-txt"
          style={{
            margin: "2px 0",
            fontSize: "8px",
            lineHeight: "1.2",
          }}
        >
          3. I/We agree that standard terms and conditions apply for this
          shipment and liability to terms and conditions. Warsaw Convention amy
          apply. I/We Service Liability shall not exceed US$100 for any
          shipment.
        </div>
        <div
          className="print-customer-invoice-pdf-txt"
          style={{
            margin: "2px 0",
            fontSize: "8px",
            lineHeight: "1.2",
          }}
        >
          4. /The Shipper also here by authorize forward the shipment in full or
          part their convenience
        </div>
        <div
          className="print-customer-invoice-pdf-txt"
          style={{
            margin: "2px 0",
            fontSize: "8px",
            lineHeight: "1.2",
          }}
        >
          5. The Shipper also here by authorize and their Counterpart India to
          clear the parcel on behalf of me and same should be delivered to the
          Consignee address.
        </div>
      </td>
    </tr>
  );

  // Function to render signature and seal - FIXED POSITION - OPTIMIZED FOR 70 ITEMS
  const renderSignatureAndSeal = (item) => (
    <tr>
      <td
        colSpan={3}
        style={{
          height: "90px",
          verticalAlign: "top",
          padding: "8px",
        }}
      >
        <div
          className="print-customer-invoice-pdf-txt"
          style={{ fontSize: "11px", marginBottom: "8px", fontWeight: "bold" }}
        >
          Customer Signature
        </div>
        {item.signature ? (
          <div style={{ display: "block", marginTop: "5px" }}>
            <img src={item.signature} height="60px" width="60px" />
          </div>
        ) : (
          <div
            style={{
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "9px",
              color: "#999",
            }}
          ></div>
        )}
      </td>
      <td
        colSpan={4}
        style={{
          height: "90px",
          verticalAlign: "top",
          textAlign: "right",
          padding: "8px",
        }}
      >
        <div
          className="print-customer-invoice-pdf-txt"
          style={{
            textAlign: "right",
            marginBottom: "8px",
            fontSize: "11px",
            fontWeight: "bold",
          }}
        >
          Company SEAL
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "8px",
            height: "60px",
          }}
        >
          <img
            src={Companyseal}
            height="60px"
            width="60px"
            style={{
              display: "block",
            }}
          />
          {item.collection && item.collection.driver_signature ? (
            <img
              src={item.collection && item.collection.driver_signature}
              height="60px"
              width="60px"
              style={{
                display: "block",
              }}
            />
          ) : null}
        </div>
      </td>
    </tr>
  );

  useEffect(() => {
    loadBoxesViaAwb();
  }, []);

  useEffect(() => {
    getExchangeRates(1, 10);
  }, []);

  const getExchangeRates = async (_page, _take) => {
    try {
      setIsLoading2(true);
      let api = API.EXCHANGE_RATE_LIST;
      let obj = {
        page: _page,
        take: _take,
      };
      const excData = await POST(api, obj);
      if (excData?.status) {
        setexchangeRates(excData?.data);
        setSelectedRate(excData?.data[0]);
        setMeta(excData?.meta);
        setIsLoading2(false);
      } else {
        message.error("No data found");
        setIsLoading2(false);
      }
    } catch (err) {
      message.error("Oops.Something went");
      setIsLoading2(false);
    }
  };

  const onSelectChange = (newSelectedRowKeys, rowDetails) => {
    console.log(newSelectedRowKeys);
    console.log(rowDetails[0]);
    setSelectedRate(rowDetails[0]);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
    {
      title: "From Date",
      dataIndex: "from_date",
      key: "from_date",
      render: (text) => <a>{moment(text).format("ll")}</a>,
    },
    {
      title: "To Date",
      dataIndex: "to_date",
      key: "to_date",
      render: (text) => <a>{moment(text).format("ll")}</a>,
    },
    {
      title: "SAR - USD",
      dataIndex: "sar_usd",
      key: "sar_usd",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "SAR - INR",
      dataIndex: "sar_inr",
      key: "sar_inr",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "INR - SAR",
      dataIndex: "inr_sar",
      key: "inr_sar",
      render: (text) => <a>{text}</a>,
    },
  ];

  const loadBoxesViaAwb = () => {
    const AWBID = props?.selected && props?.selected[0]?.id;
    let URL = API.BASR_URL + API.BOXES_VIA_AWB + AWBID;
    axios
      .get(URL, {
        headers: Headers(),
      })
      .then(function (response) {
        if (response?.status === 200) {
          let data = response?.data;
          setData(data);
          setIsLoading(false);
        } else {
          message.error("Ooops. Something went wrong...!");
          setIsLoading(false);
        }
      });
  };

  const downloadTiff = async () => {
    setLoading(true);
    try {
      const zip = new JSZip();
      const totalPages = data?.length;

      for (let page = 0; page < totalPages; page++) {
        const currentPage = data[page];
        setData([currentPage]);
        const content = componentRef.current;

        const canvas = await html2canvas(content, {
          useCORS: true,
          scrollY: window.scrollY + page * window?.innerHeight,
          width: 800,
          height: 1100,
        });

        const tiffFilename = `${data[page]?.box_number}.tif`;
        const blobPromise = new Promise((resolve) =>
          canvas.toBlob(resolve, "image/tiff")
        );
        const blob = await blobPromise;

        zip.file(tiffFilename, blob);
      }

      zip.generateAsync({ type: "blob" }).then((zipBlob) => {
        saveAs(zipBlob, "Customs_Pages.zip");
      });
    } catch (error) {
      console.error("Error capturing pages:", error);
    }

    loadBoxesViaAwb();
    setLoading(false);
  };

  // Custom sorting function for box_number
  const sortBoxNumber = (a, b) => {
    const boxA = a.box_number.toString().trim();
    const boxB = b.box_number.toString().trim();

    // Sort alphanumerically in ascending order
    return boxA.localeCompare(boxB, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  };

  return (
    <div>
      <Modal
        visible={props.visible}
        width={850}
        onCancel={props.onClose}
        footer={false}
      >
        {data?.length ? (
          <ReactToPrint
            trigger={() => <Button type="primary">Print</Button>}
            content={() => componentRef.current}
          />
        ) : null}
        &nbsp;
        {data?.length ? (
          <Button type="primary" onClick={downloadTiff}>
            {Loading ? <Spin /> : "Download Tiff"}
          </Button>
        ) : null}
        {!showExcel ? (
          <>
            <div className="modal-table-header">Select Rate</div>
            <div
              style={{
                height: "300px",
                width: "100%",
                overflow: "scroll",
              }}
            >
              <>
                <Table
                  rowKey="id"
                  size="small"
                  pagination={false}
                  columns={columns}
                  rowSelection={{ type: "radio", ...rowSelection }}
                  dataSource={exchangeRates}
                />
                <br />
                <Pagination
                  total={meta?.total_count}
                  showSizeChanger
                  defaultCurrent={meta?.page}
                  showTotal={(total) => `Total ${meta?.total_count}`}
                  onChange={(page, pageSize) => {
                    setPage(page);
                    setTake(pageSize);
                    getExchangeRates(page, pageSize);
                  }}
                />
              </>
            </div>
            <br />
          </>
        ) : null}
        <hr />
        <div ref={componentRef}>
          {isLoading ? (
            <div className="print-customs-box">
              <img src={documentloader} />
            </div>
          ) : (
            <>
              {data && data?.length ? (
                <>
                  {data
                    ?.sort(sortBoxNumber) // Updated sorting with custom function
                    .map((item) => {
                      let basicValue = Number(
                        item?.boxe_item?.reduce(function (tot, arr) {
                          return (
                            Number(tot) +
                            Number(
                              arr?.value *
                                arr?.quantity *
                                Number(selectedRate?.sar_usd)
                            )
                          );
                        }, 0)
                      ).toFixed(2);

                      let frieghtValue = Number(basicValue * 0.2).toFixed(2);
                      let InsuranceValue = Number(basicValue * 0.01125).toFixed(
                        2
                      );

                      let totalValue = Number(
                        Number(basicValue) +
                          Number(frieghtValue) +
                          Number(InsuranceValue)
                      ).toFixed(2);

                      const {
                        firstPageItems,
                        remainingItems,
                        hasMultiplePages,
                      } = splitItemsIntoPages(item.boxe_item);

                      return (
                        <>
                          {/* First Page - Fixed layout with seal, signature, and terms */}
                          <div
                            key={`${item.id}-page1`}
                            style={{
                              pageBreakAfter: "always",
                              breakAfter: "page",
                              minHeight: "297mm", // A4 height
                              position: "relative",
                            }}
                          >
                            <div
                              className="print-customs-page"
                              style={{
                                height: "100%",
                                pageBreakInside: "avoid",
                                pageBreakAfter: "always",
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <table
                                className="print-customs-table"
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  flex: "1",
                                }}
                              >
                                {/* Header Section - OPTIMIZED FOR 70 ITEMS */}
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{
                                      padding: "8px",
                                      verticalAlign: "top",
                                    }}
                                  >
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "15px",
                                        lineHeight: "1.2",
                                        margin: "0",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      <div>SAHARI INTERNATIONAL</div>
                                      <div>COURIER SERVICES</div>
                                    </div>
                                  </td>
                                  <td
                                    colSpan={5}
                                    style={{
                                      padding: "8px",
                                      textAlign: "right",
                                      verticalAlign: "top",
                                    }}
                                  >
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "13px",
                                        marginBottom: "3px",
                                        textAlign: "right",
                                        margin: "0",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      AIRWAY BILL NO
                                    </div>
                                    <div style={{ textAlign: "right" }}>
                                      <Barcode
                                        value={item?.box_number}
                                        height="35"
                                        font="Montserrat-Regular"
                                        fontSize={11}
                                      />
                                    </div>
                                  </td>
                                </tr>

                                {/* Shipment Details Table - 7 columns as per image - OPTIMIZED */}
                                <tr>
                                  <td colSpan={7}>
                                    <table
                                      style={{
                                        width: "100%",
                                        fontSize: "9px",
                                        borderCollapse: "collapse",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      <tr>
                                        <th
                                          style={{
                                            width: "14.28%",
                                            textAlign: "center",
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            backgroundColor: "#f5f5f5",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            DATE
                                          </div>
                                        </th>
                                        <th
                                          style={{
                                            width: "14.28%",
                                            textAlign: "center",
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            backgroundColor: "#f5f5f5",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            ORIGIN
                                          </div>
                                        </th>
                                        <th
                                          style={{
                                            width: "14.28%",
                                            textAlign: "center",
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            backgroundColor: "#f5f5f5",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            DESTINATION
                                          </div>
                                        </th>
                                        <th
                                          style={{
                                            width: "14.28%",
                                            textAlign: "center",
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            backgroundColor: "#f5f5f5",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            REFERENCE NO
                                          </div>
                                        </th>
                                        <th
                                          style={{
                                            width: "14.28%",
                                            textAlign: "center",
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            backgroundColor: "#f5f5f5",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            PIECES
                                          </div>
                                        </th>
                                        <th
                                          style={{
                                            width: "14.28%",
                                            textAlign: "center",
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            backgroundColor: "#f5f5f5",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            WEIGHT
                                          </div>
                                        </th>
                                        <th
                                          style={{
                                            width: "14.28%",
                                            textAlign: "center",
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            backgroundColor: "#f5f5f5",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            INVOICE VALUE
                                          </div>
                                        </th>
                                      </tr>
                                      <tr>
                                        <td
                                          style={{
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            textAlign: "center",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            {moment(item?.createdAt).format(
                                              "DD-MM-YYYY"
                                            )}{" "}
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            textAlign: "center",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            SAUDI ARABIA
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            textAlign: "center",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            {item?.country?.length > 2
                                              ? item?.country
                                              : item?.collection &&
                                                item?.collection
                                                  ?.recivercountries &&
                                                item?.collection
                                                  ?.recivercountries?.name}
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            textAlign: "center",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            {item?.box_ref_no
                                              ? item?.box_ref_no
                                              : item?.referance_details
                                              ? item?.referance_details
                                              : ""}
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            textAlign: "center",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            1
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            textAlign: "center",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            {item?.adjustment_weight || item?.chargable_weight}
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #bfbfbf",
                                            padding: "2px",
                                            textAlign: "center",
                                            fontSize: "8px",
                                          }}
                                        >
                                          <div
                                            className="print-customer-invoice-pdf-txt"
                                            style={{ margin: "0" }}
                                          >
                                            ${totalValue}
                                          </div>
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>

                                {/* Declaration Section - OPTIMIZED */}
                                <tr>
                                  <td
                                    colSpan={3}
                                    style={{
                                      padding: "5px",
                                      verticalAlign: "top",
                                      border: "1px solid #bfbfbf",
                                    }}
                                  >
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "10px",
                                        marginBottom: "2px",
                                        margin: "0",
                                      }}
                                    >
                                      DECLARATION
                                    </div>
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "8px",
                                        lineHeight: "1.1",
                                        margin: "0",
                                      }}
                                    >
                                      shipper certifies that the nature of goods
                                      is as AIRWAY BILL the shipper agree to and
                                      accept the contract conditions on the
                                      reverse side here of and acknowledges that
                                      the goods described herein is accepted by
                                      SAHARI INTERNATIONAL COURIER SERVICE for
                                      clearance to said contract condition.
                                      shipper declares that goods carried under
                                      this consignmet contain no DANGEROUS
                                      GOODS, as described under the IATA
                                      dangerous goods regulation.
                                    </div>
                                  </td>
                                  <td
                                    colSpan={4}
                                    style={{
                                      padding: "5px",
                                      verticalAlign: "top",
                                      border: "1px solid #bfbfbf",
                                    }}
                                  >
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "8px",
                                        lineHeight: "1.1",
                                        margin: "0",
                                      }}
                                    >
                                      I <b>{item?.iqama_name}</b> ID:{" "}
                                      <b>{item?.iqama_number}</b> holder of
                                      Indian Passport No/Aadhaar No: N/A Do here
                                      by appointed SAHARI INTERNAIONAL COURIER
                                      SERVICES as my authorised agent to do the
                                      courier clearance in india for me and
                                      sending to <b>{item?.adhar_name}</b> as a
                                      gift consignment
                                    </div>
                                  </td>
                                </tr>

                                {/* Invoice/Packing List Title - OPTIMIZED FOR 70 ITEMS */}
                                <tr>
                                  <td colSpan={7}>
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "13px",
                                        textAlign: "center",
                                        margin: "4px 0",
                                        padding: "5px",
                                        backgroundColor: "#f5f5f5",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      INVOICE/PACKING LIST
                                    </div>
                                  </td>
                                </tr>

                                {/* Sender and Consignee Section - OPTIMIZED */}
                                <tr>
                                  <td
                                    colSpan={3}
                                    style={{
                                      padding: "5px",
                                      verticalAlign: "top",
                                      border: "1px solid #bfbfbf",
                                    }}
                                  >
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "10px",
                                        marginBottom: "2px",
                                        margin: "0",
                                      }}
                                    >
                                      Sender Name & Address
                                    </div>
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "8px",
                                        lineHeight: "1.1",
                                        marginBottom: "1px",
                                        margin: "0",
                                      }}
                                    >
                                      {item?.iqama_name} ID:{" "}
                                      {item?.iqama_number}
                                    </div>
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "8px",
                                        lineHeight: "1.1",
                                        marginBottom: "1px",
                                        margin: "0",
                                      }}
                                    >
                                      {item?.address}
                                    </div>
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "8px",
                                        lineHeight: "1.1",
                                        marginBottom: "5px",
                                        margin: "0",
                                      }}
                                    >
                                      {item?.sender_mobile}
                                    </div>

                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "10px",
                                        marginBottom: "2px",
                                        margin: "0",
                                      }}
                                    >
                                      Consignee Name & Address
                                    </div>
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "8px",
                                        lineHeight: "1.1",
                                        marginBottom: "1px",
                                        margin: "0",
                                      }}
                                    >
                                      {item?.adhar_name}
                                    </div>
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "8px",
                                        lineHeight: "1.1",
                                        marginBottom: "1px",
                                        margin: "0",
                                      }}
                                    >
                                      {item?.adhar_address}, {item?.pin}
                                    </div>
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "8px",
                                        lineHeight: "1.1",
                                        marginBottom: "1px",
                                        margin: "0",
                                      }}
                                    >
                                      {item?.district}
                                    </div>
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "8px",
                                        lineHeight: "1.1",
                                        marginBottom: "1px",
                                        margin: "0",
                                      }}
                                    >
                                      {item?.state}
                                    </div>
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "8px",
                                        lineHeight: "1.1",
                                        marginBottom: "1px",
                                        margin: "0",
                                      }}
                                    >
                                      {item?.country?.length > 2
                                        ? item?.country
                                        : item?.collection &&
                                          item?.collection?.recivercountries &&
                                          item?.collection?.recivercountries
                                            ?.name}
                                    </div>
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "8px",
                                        lineHeight: "1.1",
                                        margin: "0",
                                      }}
                                    >
                                      {item?.reciver_mobile1}
                                    </div>
                                  </td>
                                  <td
                                    colSpan={4}
                                    style={{
                                      padding: "5px",
                                      verticalAlign: "top",
                                      border: "1px solid #bfbfbf",
                                    }}
                                  >
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{
                                        fontSize: "10px",
                                        marginBottom: "2px",
                                        textAlign: "center",
                                        margin: "0",
                                      }}
                                    >
                                      Gifts For Personal Use Only
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          marginRight: "5px",
                                          backgroundColor: "#f0f0f0",
                                          padding: "2px",
                                          borderRadius: "2px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            fontSize: "10px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          P
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "10px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          O
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "10px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          D
                                        </div>
                                      </div>
                                      <div style={{ flex: 1 }}>
                                        <div
                                          className="print-customer-invoice-pdf-txt"
                                          style={{
                                            fontSize: "8px",
                                            lineHeight: "1.1",
                                            marginBottom: "2px",
                                            margin: "0",
                                          }}
                                        >
                                          I, the undersigned on behalf of the
                                          above sender/shipper acknowledgement
                                          the receipt of goods in good condition
                                        </div>
                                        <div
                                          className="print-customer-invoice-pdf-txt"
                                          style={{
                                            fontSize: "8px",
                                            lineHeight: "1.1",
                                            marginBottom: "1px",
                                            margin: "0",
                                          }}
                                        >
                                          <b>Receiver Name:</b>{" "}
                                          {item?.adhar_name}
                                        </div>
                                        <div
                                          className="print-customer-invoice-pdf-txt"
                                          style={{
                                            fontSize: "8px",
                                            lineHeight: "1.1",
                                            margin: "0",
                                          }}
                                        >
                                          <b>Signature:</b>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>

                                {/* Items Table - FLEXIBLE HEIGHT */}
                                <tr style={{ flex: "1" }}>
                                  <td
                                    colSpan={7}
                                    style={{ verticalAlign: "top" }}
                                  >
                                    {renderItemsTable(
                                      firstPageItems,
                                      0,
                                      true,
                                      basicValue,
                                      frieghtValue,
                                      InsuranceValue,
                                      totalValue
                                    )}
                                  </td>
                                </tr>

                                {/* Terms and Conditions */}
                                {renderTermsAndConditions(item)}

                                {/* Signature and Seal - FIXED AT BOTTOM */}
                                {renderSignatureAndSeal(item)}
                              </table>
                            </div>
                          </div>

                          {/* Additional Pages for remaining items */}
                          {hasMultiplePages &&
                            (() => {
                              const itemsPerPage = calculateItemsPerPage(
                                remainingItems.length
                              );
                              const totalRemainingPages = Math.ceil(
                                remainingItems.length / itemsPerPage
                              );

                              return Array.from(
                                { length: totalRemainingPages },
                                (_, pageIndex) => {
                                  const startIndex =
                                    firstPageItems.length +
                                    pageIndex * itemsPerPage;
                                  const currentPageItems = remainingItems.slice(
                                    pageIndex * itemsPerPage,
                                    (pageIndex + 1) * itemsPerPage
                                  );

                                  return (
                                    <div
                                      key={`${item.id}-page${pageIndex + 2}`}
                                      style={{
                                        pageBreakAfter: "always",
                                        breakAfter: "page",
                                      }}
                                    >
                                      <div
                                        className="print-customs-page"
                                        style={{
                                          height: "max-content",
                                          pageBreakInside: "avoid",
                                          pageBreakAfter: "always",
                                        }}
                                      >
                                        <table
                                          className="print-customs-table"
                                          style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                          }}
                                        >
                                          <tr>
                                            <td colSpan={7}>
                                              <div
                                                className="print-customer-invoice-pdf-txt"
                                                style={{
                                                  fontSize: "14px",
                                                  textAlign: "center",
                                                  margin: "10px 0",
                                                  padding: "5px",
                                                  backgroundColor: "#f5f5f5",
                                                }}
                                              >
                                                INVOICE/PACKING LIST BALANCE
                                              </div>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td colSpan={7}>
                                              {renderItemsTable(
                                                currentPageItems,
                                                startIndex,
                                                false,
                                                basicValue,
                                                frieghtValue,
                                                InsuranceValue,
                                                totalValue
                                              )}
                                            </td>
                                          </tr>
                                        </table>
                                      </div>
                                    </div>
                                  );
                                }
                              );
                            })()}
                        </>
                      );
                    })}
                </>
              ) : (
                <div className="print-manifest-box1">
                  <AiOutlineCloseCircle size={50} color={"red"} />
                  <div style={{ margin: 20 }} />
                  <div>No data found.</div>
                </div>
              )}
            </>
          )}
        </div>
        {data && data?.length ? (
          <Row>
            <Col sm="6"></Col>
            <Col sm="3">
              <ReactToPrint
                trigger={() => (
                  <Button type="primary" block>
                    Print
                  </Button>
                )}
                content={() => componentRef.current}
              />
            </Col>
            <Col sm="3" block>
              <Button onClick={() => props.onClose()}>Cancel</Button>
            </Col>
          </Row>
        ) : null}
      </Modal>
    </div>
  );
}

export default PrintCustomsInvoiceModalB;
